<template>
  <v-container>
    <landing-create :content="content"></landing-create>
    <specimen-form
      :isLoading="isLoading"
      :onSubmit="onSubmit">
    </specimen-form>
  </v-container>
</template>

<script>
import LandingCreate from '../../../components/layouts/LandingCreate.vue';
import SpecimenForm from './SpecimenForm.vue';
import services from '../../../services';
import utilities from '../../../utilities';

const { ErrorMessageUtil } = utilities;
const { biobankRegistry } = services;
const { caseSpecimenService } = biobankRegistry;

export default {
  name: 'SpecimenCreate',
  components: {
    SpecimenForm,
    LandingCreate,
  },
  data: () => ({
    isLoading: false,
    content: {
      pageTitle: 'Create Specimen',
      enableBackButton: true,
    },
  }),
  methods: {
    async onSubmit(data) {
      this.isLoading = true;

      try {
        const { _id: id } = await caseSpecimenService.create({ specimen: data });

        const { barcodeAttachment } = data;
        if (barcodeAttachment) {
          const formData = new FormData();
          formData.append('attachment', barcodeAttachment[0]);
          const specimenId = id;
          await caseSpecimenService.uploadBarcode({ id: specimenId, formData });
        }

        this.$snackbar.showOk({ text: 'Successfully created specimen!' });

        this.$router.replace({ name: 'specimen.list', params: { id } });
      } catch (e) {
        const error = e.response.data;
        console.log('error', error);
        this.$snackbar.showBad({
          text: ErrorMessageUtil.transform(error),
        });
      }
      this.isLoading = false;
    },
  },
};
</script>
